import { offset as modifier } from '@popperjs/core/lib/modifiers';

export const offset = modifier;
